import { countMessagesSent } from '../queries/countMessagesSent'

export const totalMessagesSentGauge = {
  description:
    'Total number of outbound emails sent, excluding auto-replies. Includes outbound mails sent by rule actions.',
  queries: [countMessagesSent],
  title: 'Emails Sent',
}
